import React from 'react'
import { Box, Button, Heading } from 'grommet'
import { useNavigate } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import { signOut } from 'aws-amplify/auth'

export const AppBar = (props) => (
  <Box
    tag='header'
    direction='row'
    align='center'
    justify='between'
    background='brand'
    pad={{ left: 'medium', right: 'small', vertical: 'small' }}
    elevation='medium'
    style={{ zIndex: '1' }}
    {...props}
  />
)

function Header({ isProd }) {
  const navigate = useNavigate()

  const handleSignOut = async () => {
    try {
      await signOut()
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  return (
    <AppBar>
      <Heading className='header' level='3' margin='none' onClick={() => { navigate('/') }}>LOCMAN BUGFIX</Heading>
      <Button
        label='Create Project'
        onClick={() => { navigate('/bugfix/add') }}
      />
      {isProd && (
        <Button
          label='Sign Out'
          onClick={handleSignOut}
        />
      )}
    </AppBar>
  )
}

Header.propTypes = {
  isProd: PropTypes.bool
}

export default Header
